import React from 'react';
import PropTypes from 'prop-types';
import { AutoComplete } from 'material-ui';
import Search from 'material-ui/svg-icons/action/search';
import { StyleSheet, css } from 'aphrodite';

import OurismanTravelTheme from '../../ourismanTravelTheme';
import search from '../../rest';

export default class GlobalSearchBox extends React.Component {
  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      searchResults: [],
    };
  }

  handleUpdateSearchBox = (value) => {
    search('trip', value).then((response) => {
      const { objects } = response;
      this.setState({
        searchResults: objects.map(object => ({
          text: object.tripName,
          value: object.id,
        })),
      });
    });
  }

  tripSelected = (selected, index) => {
    let { value } = selected;
    const { searchResults } = this.state;

    if (index === -1) {
      if (searchResults.length === 0) {
        return;
      }
      value = searchResults[0].value;
    }

    this.props.history.push(`/trips/${value}/`);
  }

  render() {
    const { searchResults } = this.state;

    return (<div className={css(styles.searchContainer)}>
      <AutoComplete
        name='global-search'
        dataSource={searchResults}
        className={css(styles.searchBoxStyle)}
        menuStyle={{ width: 500 }}
        listStyle={{ width: 500 }}
        onUpdateInput={this.handleUpdateSearchBox}
        onNewRequest={this.tripSelected}
        filter={() => true}
      />
      <Search className={css(styles.largeIconStyle)} />
    </div>);
  }
}

const styles = StyleSheet.create({
  largeIconStyle: {
    position: 'relative',
    left: -24,
    top: 7,
    color: OurismanTravelTheme.palette.alternateTextColor,
  },
  largeTextFieldStyle: {
    position: 'relative',
    top: -10,
    color: 'red',
  },
  searchBoxStyle: {
    color: OurismanTravelTheme.palette.secondaryTextColor,
    WebkitTextFillColor: OurismanTravelTheme.palette.secondaryTextColor,
    maxWidth: 256,
  },
  searchContainer: {
    '@media (max-width: 800px)': {
      display: 'none',
    },
  },
});



// WEBPACK FOOTER //
// /src/components/Container/GlobalSearchBox.js